import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '@/store'
import router from '@/router'
import {getCookieToken} from '@/utils/auth'

let show401Message = false
let lastToken = ''
// 创建axios实例
const service = function (api) {
	let instanceAxios = axios.create({
		baseURL: api,
		timeout: 120000, // 请求超时时间
		withCredentials: true
	})
	// request拦截器
	instanceAxios.interceptors.request.use(config => {

		let token = getCookieToken()
		// 请求之前检测是否在其他王章切换了账户，如果已经切换，加载页面
		if (token && lastToken && token !== lastToken) {
			location.reload()
			return
		}
		lastToken = token
		let tokenKey = store.state.app.tokenKey

		if (token) {
			config.headers[tokenKey] = token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
		}
		return config
	}, error => {
		// Do something with request error
		console.log(error) // for debug
		Promise.reject(error)
	})

	// respone拦截器
	instanceAxios.interceptors.response.use(
		response => {
			const res = response.data
			if (res.status !== 200) {
				store.commit('user/setUserStatus', '')
				if (res.status === 401) {
					if (!show401Message) {
						store.commit('app/setRedirectUrl', location.href)
						store.commit('user/logoutMutaion')
						MessageBox.confirm(res.msg || '用户登录信息失效，可重新登录', '提示', {
							confirmButtonText: '重新登录',
							showCancelButton: false,
							type: 'warning',
							confirmButtonClass: 'login-out'
						}).then(() => {

							router.push({name: 'login'})
						}).catch(e => {
							router.push({name: 'login'})
						})
					}
					show401Message = true

				} else {
					show401Message = false
				}

				if (res.status === 403) {
					store.commit('user/setUserStatus', 'unregister')
				}
				if (res.status === 201) {
					return response
				}
				if (res.type === 'multipart/form-data') {
					return response
				}
				if(res.status === 450){
					// 参数错误，由程序处理
					return response
				}
				if (res.msg) {
					Message({
						message: res.msg,
						type: 'error',
						duration: 5 * 1000
					})
					return response
				}
				return Promise.reject('error')
			}
			return response
		},
		error => {
			console.log('err' + error)// for debug
			Message({
				message: error.message,
				type: 'error',
				duration: 5 * 1000
			})
			return Promise.reject(error)
		}
	)

	return instanceAxios
}

export default service(process.env.AUTHOR_API + '/authors')



// WEBPACK FOOTER //
// ./src/api/fetch.js